<template>
  <div class="bar-1">
    <div class="grid">
      <div class="news-container">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list.slice(0, 8)"
          :key="item.id"
          class="news-container__item"
        >
          <div class="card" :class="`card-${index + 1}`">
            <div class="card__img">
              <div class="card__category-img">{{ item.sub_category.name }}</div>
              <ImageContainer
                style="overflow: visible; boreder-radius: 0px"
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div class="card__descr">
              <div class="card__category-descr">
                {{ item.sub_category.name }}
              </div>
              <div class="card__title limited-text">
                {{ item.title }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
            <div class="card__brief">
              <div class="limited-text" style="--snup:5">
                {{ item.brief }}
              </div>
              <div class="data-news-brief">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>
        <div class="bg-news-container"></div>
      </div>
      <div class="telegram">
        <div class="overflow-head "></div>
        <div style="" class="overflow-bottom"></div>
        <iframe
          class="telegram__iframe"
          ref="iframe"
          src="https://xn--r1a.website/s/shmirziyoyev"
        ></iframe>
      </div>
      <div class="bottom-news">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: list[8].url }
            })
          "
          class="card card-9"
        >
          <div class="card__img">
            <div class="card__category-img">
              {{ list[8].sub_category.name }}
            </div>
            <ImageContainer
              style="overflow: hidden; boreder-radius: 0px"
              class="img"
              :src="list[8].image.medium"
              :thumb="list[8].image.thumbnail"
              :alt="list[8].title"
            />
          </div>
          <div class="card__descr">
            <div class="card__category-descr">
              {{ list[8].sub_category.name }}
            </div>
            <div class="card__title limited-text">
              {{ list[8].title }}
            </div>
            <div class="data-news">
              <span class="day">{{ handleDate(list[8].pub_date) }},</span>
              <span class="time">{{ handleTime(list[8].pub_date) }}</span>
            </div>
          </div>
          <div class="card__brief">
            <div class="limited-text" style="--snup:5">
              {{ list[8].brief }}
            </div>
            <div class="data-news-brief">
              <span class="day">{{ handleDate(list[8].pub_date) }},</span>
              <span class="time">{{ handleTime(list[8].pub_date) }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
import { onMounted, ref } from "vue";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    const iframe = ref(null);

    const setIframeStyles = () => {
      const elem = iframe.value.querySelector("body");
      console.log(iframe.value);
      console.log(elem);
    };

    onMounted(() => {
      iframe.value.onload = () => setIframeStyles();
    });

    return {
      ...useFormatter(),
      iframe
    };
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__descr {
    --snup: 4;
  }
  &__brief {
    display: none;
  }
  &__img {
    overflow: hidden;
    :deep() .main-image img {
      border-radius: 0px;
      overflow: visible;
    }
  }
}
.bg-news-container {
  display: none;
}
.bar-1 {
  width: 100%;
  padding: 40px 0 60px;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    bottom: 0;
    right: 0;
    width: 48%;
    height: 1px;
    background: #c4c4c4;
  }
  &::before {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    width: 48%;
    height: 1px;
    background: #c4c4c4;
  }
  @media screen and (max-width: 992px) {
    padding-bottom: 15px;
    &::after,
    &::before {
      content: none;
    }
  }
}
.telegram {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 992px) {
    // width: 100vw !important;
  }
  .overflow-head {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 48px;
    background-color: white;
    @media screen and (max-width: 1366px) {
      height: 69px;
      width: 25px;
    }
    @media screen and (max-width: 992px) {
      width: 20px;
      height: 48px;
    }
  }
  .overflow-bottom {
    position: absolute;
    top: 48px;
    right: 0;
    width: 20px;
    height: calc(100% - 51px);
    background-color: #e5ebef;
    @media screen and (max-width: 1366px) {
      // background: red;
      top: 69px;
      width: 25px;
      height: calc(100% - 69px);
    }
    @media screen and (max-width: 992px) {
      width: 20px;
      top: 48px;
      height: calc(100% - 51px);
    }
  }
  &::before {
    content: "";
    position: absolute;
    top: 48px;
    left: 2vw;
    background: rgb(229, 235, 239);
    width: 111%;
    height: calc(100% - 48px);
    border-bottom-left-radius: 5px;
    z-index: -1;
    @media screen and (max-width: 1366px) {
      // background: red;
      top: 69px;
      width: 113.2%;

      height: calc(100% - 69px);
    }
    @media screen and (max-width: 992px) {
      display: none;
      height: 100%;
      width: 100%;
      left: 0;
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 2vw;

    background: #fff;
    width: 111%;
    height: 48px;
    border-top-left-radius: 5px;
    z-index: -1;
    @media screen and (max-width: 1366px) {
      // background: red;
      height: 69px;
      width: 113.2%;

      // height: calc(100% - 69px);
    }
    @media screen and (max-width: 992px) {
      // height: 100%;
      // width: 100%;
      // left: 0;
      display: none;
    }
  }
  &__iframe {
    border: 0px;
    height: 100%;
    width: 100%;
    padding-left: 4vw;
    z-index: 2;
    @media screen and (max-width: 992px) {
      padding: 0;
    }
  }
  // background: #C4C4C4;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 30%;
  // gap: 95px;
}
.news-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  gap: 10px 2vw;
  &__item:nth-child(4) {
    grid-column: span 2;
  }
}

.card-1,
.card-2,
.card-3,
.card-5,
.card-6,
.card-7,
.card-8 {
  .card__img {
    // height: 267px;
    .img {
      padding-bottom: 71%;
    }
  }
  .card__category-img {
    display: block;
    position: absolute;
    top: -1px;
    left: -1px;
    z-index: 2;
    background: var(--dark-bg);
    padding: 0.3rem;
  }
  .card__img {
    position: relative;
  }
  .card__descr {
    background: var(--dark-bg);
    width: 80%;
    margin-left: auto;
    transform: translateY(-40px);
    position: relative;
    padding: 20px 20px 0;
  }
  .card__category-descr {
    display: none;
  }
}
.card-4 {
  display: flex;
  .card__category-img {
    display: none;
  }
  .card__img {
    flex: 0 0 20vw;
    // height: 293px;
    position: relative;
    .img {
      padding-bottom: 75%;
    }
    &::after {
      position: absolute;
      content: "";
      top: 0;
      right: 0;
      width: 155px;
      height: 100%;
      z-index: 2;
      background: linear-gradient(
        90deg,
        rgba(21, 35, 49, 0) 0%,
        rgba(21, 35, 49, 0.0086472) 6.67%,
        rgba(21, 35, 49, 0.03551) 13.33%,
        rgba(21, 35, 49, 0.0816599) 20%,
        rgba(21, 35, 49, 0.147411) 26.67%,
        rgba(21, 35, 49, 0.231775) 33.33%,
        rgba(21, 35, 49, 0.331884) 40%,
        rgba(21, 35, 49, 0.442691) 46.67%,
        rgba(21, 35, 49, 0.557309) 53.33%,
        rgba(21, 35, 49, 0.668116) 60%,
        rgba(21, 35, 49, 0.768225) 66.67%,
        rgba(21, 35, 49, 0.852589) 73.33%,
        rgba(21, 35, 49, 0.91834) 80%,
        rgba(21, 35, 49, 0.96449) 86.67%,
        rgba(21, 35, 49, 0.991353) 93.33%,
        #152331 100%
      );
    }
  }
  .card__descr {
    display: flex;
    flex-direction: column;
    justify-content: center;
    transform: translateX(-40px);
    z-index: 2;
  }

  .card__title {
    margin-top: 0.5rem;
  }
}
.bottom-news {
  margin-top: 50px;
  grid-column: span 3;
  // height: 275px;
  height: 15vw;
  .card-9 {
    // display: grid;
    // grid-template-columns: minmax(368px, 50px) minmax(140px, 1fr) 1fr;
    background: #fff;
    display: flex;
    // justify-content: center;
    align-items: center;
    height: 100%;
  }
  .card__title {
    color: #121212;
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 26px;
    line-height: 36px;
    --snup: 4;
  }
  .card__category-img {
    display: none;
  }
  .card__descr {
    flex: 0 0 30%;
    padding: 0 1.5rem 0 0;
    height: 224px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .data-news {
      display: none;
    }
    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 1px;
      height: 224px;
      background: #c4c4c4;
    }
    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 60%;
      height: 1px;
      background: #c4c4c4;
    }
  }
  .card__category-descr {
    margin-bottom: 1rem;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    color: rgba(18, 18, 18, 0.7);
  }
  .data-news-brief {
    display: block;
    color: rgba(18, 18, 18, 0.8);
  }
  .card__img {
    grid-column: span 1;
    // width: 400px;
    flex: 0 0 20%;
    height: 100%;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      right: 0;
      top: 0;
      width: 160px;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.0086472) 6.67%,
        rgba(255, 255, 255, 0.03551) 13.33%,
        rgba(255, 255, 255, 0.0816599) 20%,
        rgba(255, 255, 255, 0.147411) 26.67%,
        rgba(255, 255, 255, 0.231775) 33.33%,
        rgba(255, 255, 255, 0.331884) 40%,
        rgba(255, 255, 255, 0.442691) 46.67%,
        rgba(255, 255, 255, 0.557309) 53.33%,
        rgba(255, 255, 255, 0.668116) 60%,
        rgba(255, 255, 255, 0.768225) 66.67%,
        rgba(255, 255, 255, 0.852589) 73.33%,
        rgba(255, 255, 255, 0.91834) 80%,
        rgba(255, 255, 255, 0.96449) 86.67%,
        rgba(255, 255, 255, 0.991353) 93.33%,
        #ffffff 100%
      );
    }
  }
  .card__brief {
    flex: 0 0 50%;

    width: 100%;
    padding: 0 3rem 0 1rem;
    height: 224px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 50%;
      height: 1px;
      background: #c4c4c4;
    }
    .limited-text {
      padding: 0 1rem 0 0;
    }
  }
}
.card-9 {
  .card__descr {
    .card__category-descr {
      color: rgba(18, 18, 18, 0.7) !important;
    }
    .card__title {
      color: #121212 !important;
    }
  }
}
@media screen and (max-width: 992px) {
  .bar-1 {
    position: relative;
  }
  .grid {
    grid-template-columns: repeat(6, 1fr);
    .bottom-news {
      max-width: var(--main-wrapper-width);
      margin: 0 auto;
      grid-column: 1 / span 6;
      grid-row: 1;
      width: auto;
      height: auto;
      margin-top: 0px;
      .card-9 {
        background: transparent;
        display: grid;
        grid-template-columns: auto;
        grid-template-areas:
          "title"
          "image"
          "brief";
        .card__img {
          grid-area: image;
          display: block;
          height: 516px;
          width: 100%;

          &::after {
            content: "";
            top: 0;
            height: 62px;
            left: 0;
            right: auto;
            width: 100%;
            background: linear-gradient(
              180deg,
              #0a1622 9.9%,
              rgba(10, 22, 34, 0.78) 55.58%,
              rgba(10, 22, 34, 0) 97.09%
            );
          }
          &::before {
            position: absolute;
            content: "";
            bottom: 0;
            height: 62px;
            left: 0;
            width: 100%;
            height: 60px;
            z-index: 2;
            background: linear-gradient(
              180deg,
              #0a1622 9.9%,
              rgba(10, 22, 34, 0.78) 55.58%,
              rgba(10, 22, 34, 0) 97.09%
            );
            transform: matrix(1, 0, 0, -1, 0, 0);
          }
        }
        .card__descr {
          transform: translateY(50px);
        }
        .card__title {
          width: 95%;
          margin: 0 auto;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 25px;
          line-height: 34px;
          color: #ffffff !important;
        }
        .card__category-descr {
          margin-bottom: 0;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          line-height: 25px;
          color: rgba(255, 255, 255, 0.7) !important;
          text-transform: uppercase;
        }
        .card__descr {
          height: auto;
          display: block;
          grid-area: title;
          padding: 0;
          text-align: center;
          &::after {
            content: none;
          }
          &::before {
            content: none;
          }
        }
        .card__brief {
          display: block;
          grid-area: brief;
          padding: 0;
          height: auto;
          padding: 0 1rem;
          transform: translateY(-50px);
          z-index: 2;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 24px;
          line-height: 145%;
          text-align: justify;

          color: rgba(255, 255, 255, 0.8);

          &::after {
            content: none;
          }
        }
        .data-news-brief {
          font-family: Open Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 15px;
          line-height: 20px;
          text-align: right;
          margin-top: 10px;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
    .telegram {
      // max-width: var(--main-wrapper-width);
      // margin: 0 auto;
      grid-column: span 6;
      grid-row: 2;
      .telegram__iframe {
        // padding: 0 5rem;
        height: 600px;
      }
    }
    .news-container {
      grid-column: span 6;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      margin-top: 4.5rem;
      gap: 2.2rem 0;

      &__item:nth-child(1) {
        grid-column: 1 / span 6;
      }
      &__item:nth-child(2) {
        grid-column: 1 / span 3;
        grid-row: 2 / span 2;
      }
      &__item:nth-child(3) {
        grid-column: 1 / span 3;
        grid-row: 4 / span 2;
      }
      &__item:nth-child(4) {
        grid-column: 4 / span 3;
        align-self: center;
      }
      &__item:nth-child(5) {
        grid-column: 4 / span 3;
        align-self: center;
      }
      &__item:nth-child(6) {
        grid-column: 4 / span 3;
        align-self: center;
      }
      &__item:nth-child(7) {
        grid-column: 4 / span 3;
        align-self: center;
      }
      &__item:nth-child(8) {
        grid-column: 1 / span 6;
      }
    }
    .card-1,
    .card-2,
    .card-3,
    .card-5,
    .card-6,
    .card-7,
    .card-8 {
      .card__img {
        height: auto;
      }
      .card__category-img {
        display: block;
        position: relative;
        top: 0;
        z-index: 2;
        background: var(--dark-bg);
        padding: 0.3rem;
      }
      .card__img {
        position: relative;
      }
      .card__descr {
        background: var(--dark-bg);
        width: 100%;
        margin-left: auto;
        transform: translateY(0px);
        position: relative;
        padding: 0;
      }
      .card__category-descr {
        display: none;
      }
    }
    .card-1,
    .card-8 {
      display: flex;
      gap: 1rem;
      background: #fff;

      .card__img {
        flex: 0 0 45%;
        position: relative;
        height: 285px;
        ::before {
          content: "";
          position: absolute;
          width: 158px;
          height: 100%;
          background: linear-gradient(
            270deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0.991353) 6.67%,
            rgba(255, 255, 255, 0.96449) 13.33%,
            rgba(255, 255, 255, 0.91834) 20%,
            rgba(255, 255, 255, 0.852589) 26.67%,
            rgba(255, 255, 255, 0.768225) 33.33%,
            rgba(255, 255, 255, 0.668116) 40%,
            rgba(255, 255, 255, 0.557309) 46.67%,
            rgba(255, 255, 255, 0.442691) 53.33%,
            rgba(255, 255, 255, 0.331884) 60%,
            rgba(255, 255, 255, 0.231775) 66.67%,
            rgba(255, 255, 255, 0.147411) 73.33%,
            rgba(255, 255, 255, 0.0816599) 80%,
            rgba(255, 255, 255, 0.03551) 86.67%,
            rgba(255, 255, 255, 0.0086472) 93.33%,
            rgba(255, 255, 255, 0) 100%
          );
          // transform: rotate(-90deg);
          z-index: 1;
          right: 0;
        }
      }
      .card__category-img {
        display: none;
      }
      .card__brief {
        display: block;
        margin-top: 90px;
        padding: 1rem;
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 150%;
        .data-news-brief {
          text-align: left !important;
          font-family: Open Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 18px;

          color: #121212;
        }
      }
      .card__title {
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #121212 !important;
        --snup: 2;
      }
      .card__descr {
        background: transparent;
        margin-left: auto;
        transform: translateY(20px);
        position: absolute;
        padding: 0;
        width: 50%;
        left: 45%;

        z-index: 2;
        .data-news {
          display: none;
        }
      }
      .card__category-descr {
        display: block;
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600 !important;
        font-size: 13px !important;
        line-height: 18px;
        text-transform: uppercase;
        color: rgba(18, 18, 18, 0.7) !important;
      }
    }
    .card-2,
    .card-3 {
      padding: 0 60px 0 35px;
      .card__img {
        height: 207px;

        position: relative;
      }
      .card__category-img {
        position: absolute;
      }
    }
    .card-4,
    .card-5,
    .card-6,
    .card-7 {
      display: flex;
      gap: 1rem;
      padding-right: 2rem;
      transform: translateX(-10px);
      .card__category-img {
        display: none;
      }
      .card__img {
        flex: 0 0 40%;
        position: relative;
        height: 120px;
        padding: 8px 0;
        &::after {
          content: none;
          top: 0;
          right: 0;
          width: 155px;
          height: 100%;
          z-index: 2;
          background: none;
        }
      }
      .card__category-descr {
        display: block;
      }
      .card__descr {
        // height: 120%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // justify-content: flex-start;
        transform: translateX(0px);
        z-index: 2;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .bar-1 {
    padding: 0;
  }
  .overflow-head {
    display: none;
  }
  .overflow-bottom {
    display: none;
  }
  .grid {
    .news-container {
      width: var(--main-wrapper-width);
      margin: 0 auto;
      padding: 40px 0 0px;
      gap: 0;
      grid-template-rows: auto repeat(4, 1fr) auto;
      .bg-news-container {
        display: block;
        background: var(--dark-blog-bg);
        grid-row: 2 / span 4;
        grid-column: 1 / span 6;
      }
      &__item {
        display: block;
        // align-self: start;
      }
      &__item:nth-child(1) {
        grid-column: 1 / span 3;
      }
      &__item:nth-child(2) {
        grid-column: 4 / span 3;
        grid-row: 1 / span 1;
        margin-bottom: 1.8rem;
      }
      &__item:nth-child(3) {
        grid-column: 2 / span 6;
        grid-row: 2 / span 1;
        align-self: flex-end;
        height: 100%;
      }
      &__item:nth-child(4) {
        grid-column: 2 / span 6;
        grid-row: 3 / span 1;
        height: 100%;
      }
      &__item:nth-child(5) {
        grid-column: 2 / span 6;
        grid-row: 4 / span 1;
        height: 100%;
      }
      &__item:nth-child(6) {
        grid-column: 2 / span 6;
        grid-row: 5 / span 1;
        align-self: flex-start;
        height: 100%;
      }
      &__item:nth-child(7) {
        grid-column: 1 / span 3;
        align-self: center;
        margin-top: 1.8rem;
      }
      &__item:nth-child(8) {
        grid-column: 4 / span 3;
        margin-top: 1.8rem;
      }
      &__item:nth-child(3),
      &__item:nth-child(4),
      &__item:nth-child(5) {
        position: relative;
        &::before {
          position: absolute;
          bottom: 0;
          left: -20%;
          content: "";
          width: 70px;
          height: 3px;
          background: var(--strip);
        }
      }
    }
    .bottom-news {
      .card-9 {
        .card__title {
          --snup: 3;
        }
        .card__img {
          height: 252px;
          width: 89%;
          margin: 0 auto;
          overflow: visible;
          .img {
            width: 100%;
            margin: 0 auto;
            overflow: hidden;
          }
          // .main-image {
          //   width: 90%;
          //   margin: 0 auto;
          //   // padding: 0 2rem;
          // }
        }
        .card__category-img {
          display: block;
          position: absolute;
          top: 50%;
          left: -30px;
          transform: rotate(-90deg) translateY(-50%);
          z-index: 2;
          font-family: Open Sans;
          font-style: normal;
          font-weight: bold;
          font-size: 10px;
          line-height: 14px;
          color: rgba(255, 255, 255, 0.6);
        }
        .card__category-descr {
          display: none;
        }
        .card__title {
          font-family: Roboto;
          font-style: normal;
          font-weight: bold;
          font-size: 20px;
          line-height: 25px;
          text-align: center;
          color: #ffffff !important;
        }
        .card__brief {
          font-family: Roboto;
          font-style: normal;
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
          text-align: justify;
          transform: translateY(-25px);

          color: rgba(255, 255, 255, 0.8);
          .limited-text {
            padding: 0;
          }
          .data-news-brief {
            font-family: Open Sans;
            font-style: normal;
            font-weight: normal;
            font-size: 10px;
            line-height: 14px;
            /* identical to box height */

            text-align: right;

            color: rgba(255, 255, 255, 0.6);
          }
        }
        .data-news {
          display: none;
        }
      }
    }
    .telegram {
      .telegram__iframe {
        height: 400px;
        padding: 0;
      }
    }

    .card {
      background: transparent;
      display: block;
      .card__brief {
        display: none;
      }
      .card__descr {
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        color: inherit;
      }
      .card__title {
        color: inherit;
      }
      .card__category-descr {
        color: inherit;
      }
      .data-news {
        display: block;
        position: relative;
      }
    }
    .card-1,
    .card-8 {
      .card__img {
        ::before {
          content: none;
        }
      }
    }
    .card-2,
    .card-8 {
      padding-left: 10px !important;
    }

    .card-1,
    .card-8 {
      .card__descr {
        .card__title {
          color: #fff !important;
        }
      }
    }
    .card-1,
    .card-7 {
      padding-right: 10px !important;
    }
    .card-1,
    .card-2,
    .card-8,
    .card-7 {
      padding: 0;
      transform: translate(0);

      .card__img {
        padding: 0;
        position: relative;
        height: 124px;
        &::before {
          content: none;
          display: none;
        }
      }
      .card__descr {
        margin-top: 0.5rem;
        transform: translate(0);
        .data-news {
          display: block;
          position: relative;
        }
      }
      .card__category-descr {
        display: none;
      }
      .card__category-img {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }
    .card-6 {
      display: block;
    }
    .card-3,
    .card-4,
    .card-5,
    .card-6 {
      padding: 10px 0;
      transform: translateX(-10%);
      height: 100%;
      display: flex;
      .card__img {
        display: none;
      }
      .card__category-descr {
        display: block;
      }
      .card__descr {
        background: transparent;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
}
</style>
